import React, { PureComponent } from 'react';
import RowTablaSaldos from './RowTablaSaldos';
import ModalDatosCuenta from '../ModalDatosCuenta';
import GlobalHelper from '../../../../Common/Helpers/GlobalHelper';
import TablaMovimientosSinConfirmar from './TablaMovimientosSinConfirmar';
import SelectorFechaSaldos from './SelectorFechaSaldos';

class SaldosMovimientos extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            estaDesplegado: false
        }

        this.setEstaDesplegado = this.setEstaDesplegado.bind(this);
    }

    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip();
    }
    componentDidUpdate() {
        $('[data-toggle="tooltip"]').tooltip();
    }

    validarFecha(fecha) {
        let fechaAux = fecha.split("/");
        let mesAux, fechaFinal;
 
        if (fechaAux[1].length == 1)
            mesAux = "0" + fechaAux[1];
        else
            mesAux = fechaAux[1];

        fechaFinal = mesAux + "/" + fechaAux[2];

        return fechaFinal
    }

    obtenerFechaFormatoString(fecha){ 
        let mesActual, fechaFinal;

        if (typeof (fecha) == "object") {
            mesActual = fecha.getMonth() + 1;  
            fechaFinal = (mesActual > 9 ? mesActual : '0' + mesActual) + '/' +  fecha.getFullYear(); 
        }else{
            fechaFinal = fecha;
        }

        return fechaFinal;
    }

    muestraMovimientosSinConfirmar(fecha){ 
        let mesActual, anioActual, mesAux, anioAux, muestraMovimientosSinConfirmar;

        if (typeof (fecha) == "object") {
            //obtengo mes y anio selecionado en el calendario
            mesAux = fecha.getMonth() + 1;  
            anioAux = fecha.getFullYear(); 
            //obtengo mes y anio actual
            mesActual = new Date().getMonth() + 1;
            anioActual = new Date().getFullYear();

            if(mesActual == mesAux && anioActual == anioAux)
                muestraMovimientosSinConfirmar = true;
            else{    
                muestraMovimientosSinConfirmar = false;
                this.setEstaDesplegado(false);
            }
        }else if(fecha.includes("/")){
            let fechaAux = fecha.split('/');

            mesAux = parseInt(fechaAux[0]);
            anioAux = parseInt(fechaAux[1]);
    
            mesActual = new Date().getMonth() + 1;
            anioActual = new Date().getFullYear();

            if(mesActual == mesAux && anioActual == anioAux)
                muestraMovimientosSinConfirmar = true;
            else{    
                muestraMovimientosSinConfirmar = false;
                this.setEstaDesplegado(false);
            }
        }

        return muestraMovimientosSinConfirmar;
    }

    setEstaDesplegado(estadoDesplegado) {        
        this.setState({
            estaDesplegado: estadoDesplegado 
        });
    }

    render() {
        const { state, setEstaDesplegado } = this;
        const { data, actualizarSaldosParaMostrar } = this.props;
        const { SaldoAdintar, SaldosParaMostrar, SinSaldoParaMostrar, MovimientosSinConfirmar } = data.SaldosMovimientos;
        let spinner, fechaCalendario;
        let saldoAdintarStr = ""
        let saldoNegativo = false;

        let saldoGP = data.saldoGP != null ? "$ " + GlobalHelper.ConversionDeMilesAgregandoDecimales(data.saldoGP) : 'No Disp.';
        let disponibleGP = data.disponibleGP != null ? "$ " + GlobalHelper.ConversionDeMilesAgregandoDecimales(data.disponibleGP) : 'No Disp.';

        let checkIsError = data.datosCuentaGenerales.saldoGlobal
        let mensajeModalAdvertencia = checkIsError === false ? "No fue posible obtener el o los datos correspondientes del procesador" : "No fue posible obtener estos datos del procesador, el dato Disponible GP es calculado por UALA y no por GP";

        if (saldoGP.includes("-")) {
            saldoGP = saldoGP.replace("-", "(");
            saldoGP += ")";
        }
        if (disponibleGP.includes("-")) {
            disponibleGP = disponibleGP.replace("-", "(");
            disponibleGP += ")";
        }

        if (SaldoAdintar && SaldoAdintar.length > 0) {
            if (SaldoAdintar[0].SaldoFecha < 0) saldoNegativo = true;

            saldoAdintarStr = "$ " + GlobalHelper.ConversionDeMilesAgregandoDecimales(SaldoAdintar[0].SaldoFecha);

            if (saldoNegativo) {
                saldoAdintarStr = saldoAdintarStr.replace("-", "(")
                saldoAdintarStr += ")"
            }
        } else {
            saldoAdintarStr = "No Disp.";
        }

        //Validación para fecha que se muestra en el calendario #ADT-1653
        fechaCalendario = this.obtenerFechaFormatoString(data.SaldosMovimientos.fecha);

        if (data.SaldosMovimientos.loading == true) spinner = <div className="loading" />

        if (!data.SaldosMovimientos.mostrarCalendarios) this.props.mostrarCalendario()

        return (
            <div>{spinner}
                <div className="container-fluid">
                    {((data.desdeBD || checkIsError === false) && data.SaldosMovimientos.mostrarModalAdvertencia) &&
                        <ModalDatosCuenta
                            ocultarModal={this.props.ocultarModalAdvertencia}
                            titulo={"Advertencia"}
                            mensaje={mensajeModalAdvertencia}
                        />
                    }
                    {data.SaldosMovimientos.mostrarModalSaldos &&
                        <ModalDatosCuenta
                            ocultarModal={this.props.ocultarModal}
                            titulo={"Saldos y Movimientos"}
                            mensaje={data.SaldosMovimientos.mensajeSaldos}
                        />
                    }
                    <div className="saldosActuales">Saldos Actuales</div>
                    <div className='headerSaldosTopDiv'></div>
                    <div className='tableroProcesosSingle'>
                        <div className='headerSaldosCuenta borderRightSaldos borderLeftSaldos'>
                            <div className='client-search-label-secondary'>Saldo Adintar 17</div>
                            <div className='saldoNumeroHeader'>{saldoAdintarStr}</div>
                        </div>
                        <div className='headerSaldosCuenta borderRightSaldos'>
                            <div className='client-search-label-secondary'>Saldo GP</div>
                            <div className='saldoNumeroHeader'>{saldoGP}</div>
                        </div>
                        <div className='headerSaldosCuenta borderRightSaldos'>
                            <div className='client-search-label-secondary'>Disponible GP</div>
                            <div className='saldoNumeroHeader'>{disponibleGP}</div>
                        </div>
                    </div>
                    <div className="col-md-12 contenedor-Fechas-Cuenta-Corriente">
                        <div className='CuentaSeleccionContainerCuentaCorriente'>
                            <div className="MovimientosLabel">
                                <p className="Movimientos">Movimientos</p>
                            </div>
                        </div>
                        <div className='tableroProcesosPanelSuperior' >
                            <div className='CuentaSeleccionContainerCuentaCorriente'>
                                {data && data.SaldosMovimientos.mostrarCalendarios &&
                                    <div className="contenedor-Calendario-Saldos">
                                        <div className="flechaCalendarioSaldos" onClick={() => this.props.cambiarMesPorFlecha('anterior')}>
                                            ❮
                                        </div>
                                        <div className="paddingFechasSaldos">
                                            <SelectorFechaSaldos
                                                fArguments={["fecha"]}
                                                validarFormatoFecha={this.props.validarFormatoFecha}
                                                fecha={fechaCalendario}
                                                keyDate={"fecha"}
                                                clasePicker={"date-picker-CuentaCorriente-1 form-control-Datos-Cuenta"}
                                                titulo={"Período"}
                                                maxToday={true}
                                                classLabel="labelSaldos"
                                            />
                                        </div>
                                        <div className="flechaCalendarioSaldos" onClick={() => this.props.cambiarMesPorFlecha('posterior')}>
                                            ❯
                                        </div>                                        
                                    </div>
                                }
                                {data && !data.SaldosMovimientos.fechaSaldosFormatoOk && <label className="error labelErrorSaldos">{data.SaldosMovimientos.msjErrorCalendarioSaldos}</label>}
                                
                                <div className="contenedor-RadioButton-Saldos">
                                    <div className="col-xs-12 marginRdButtonSaldos">
                                        <div className="container-radio radio-margin">
                                            <input
                                                id={"rbSaldo" + 1}
                                                type="radio"
                                                name="rbSaldo"
                                                value='C'
                                                checked={data.SaldosMovimientos.radioBtnSaldos == 'C' ? true : false}
                                                onChange={(e) => this.props.selectRadio('C')}
                                            />
                                            <label
                                                className="lbl-radioSaldos label-radioButton"
                                                htmlFor={"rbSaldo" + 1}>
                                                {"Criterio Contable"}
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-xs-12">
                                        <div className="container-radio radio-margin">
                                            <input
                                                id={"rbSaldo" + 2}
                                                type="radio"
                                                name="rbSaldo"
                                                value= 'P'
                                                checked={data.SaldosMovimientos.radioBtnSaldos == 'P' ? true : false}
                                                onChange={(e) => this.props.selectRadio('P')}
                                            />
                                            <label
                                                className="lbl-radioSaldos label-radioButton"
                                                htmlFor={"rbSaldo" + 2}>
                                                {"Corte Fecha GP"}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-1 lineBotonSaldos">
                                    <button className='botonSaldos' onClick={() => this.props.buscarMovimientos(fechaCalendario)}>Ver</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='headerSaldosBottomDiv'></div>
                    
                    {
                        this.muestraMovimientosSinConfirmar(fechaCalendario) ?                
                            <TablaMovimientosSinConfirmar setEstaDesplegado={setEstaDesplegado} estaDesplegado={state.estaDesplegado} MovimientosSinConfirmar={MovimientosSinConfirmar}/>
                             
                        : null
                    }

                    <div>
                        <table className='width100 noBorder'>
                            <thead className='saldoHeaderBorde'>
                            <tr className='height50 EditIcon paddingLeftXS paddingTopBottom header-movimientos-confirmados'>
                                <th className='movimientosTableEstilo' colSpan="4">MOVIMIENTOS CONFIRMADOS</th>
                            </tr>
                                <tr className='height50 EditIcon paddingLeftXS paddingTopBottom'>
                                    <th className='movimientosTableEstilo' style={{width: '110px'}}>FECHA</th>
                                    <th className='movimientosTableEstilo' style={{width: '424px'}}>CONCEPTO</th>
                                    <th className='movimientosTableEstilo' style={{width:'105px', alignContent:'left'}}>$</th>
                                    <th className='movimientosTableEstilo' style={{width:'105px', alignContent:'left'}}>SALDO</th>
                                </tr>
                            </thead>
                        </table>
                        <table className='width100 noBorder saldosScroll'>
                                {SaldosParaMostrar && SaldosParaMostrar.length > 0
                                    ?
                                        SaldosParaMostrar.map((saldo, index) => { return <RowTablaSaldos index={index} saldo={saldo} /> })
                                    :
                                        null
                                }
                                {SaldosParaMostrar && SaldosParaMostrar.length == 1 ||  SaldosParaMostrar.length == 0
                                    ?
                                        <tr className='Block Personeria paddingLeftXS paddingTopBottom backgroundTableLightBlue'>
                                            <td colSpan="5">{data.SaldosMovimientos.mensajeSinSaldo}</td>
                                        </tr>
                                    :
                                        null
                                }
                        </table>
                        <table className='width100 noBorder'>
                            <tr>
                                <button onClick={() => actualizarSaldosParaMostrar()} disabled={SinSaldoParaMostrar} className='btn btn-primary btn-cta width100 botonVerMas'>Ver más</button>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default SaldosMovimientos;
